
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("18ETW"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("18ETW", function(module, exports) {

let $0d4643f629a2506c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0d4643f629a2506c$var$load("cRtGo"),
    $0d4643f629a2506c$var$load("hCiBy"),
    $0d4643f629a2506c$var$load("3q2Ng"),
    $0d4643f629a2506c$var$load("jRpDi"),
    $0d4643f629a2506c$var$load("iXxzp"),
    $0d4643f629a2506c$var$load("dYtBN"),
    $0d4643f629a2506c$var$load("kNV5Y"),
    $0d4643f629a2506c$var$load("jUBhK"),
    $0d4643f629a2506c$var$load("ddJJa"),
    $0d4643f629a2506c$var$load("27glK"),
    $0d4643f629a2506c$var$load("bvY53"),
    $0d4643f629a2506c$var$load("f6ci5"),
    $0d4643f629a2506c$var$load("7jSfd"),
    $0d4643f629a2506c$var$load("4HZlX"),
    $0d4643f629a2506c$var$load("kDqHr"),
    $0d4643f629a2506c$var$load("gT8XU"),
    $0d4643f629a2506c$var$load("3GuOt"),
    $0d4643f629a2506c$var$load("3Mspc"),
    $0d4643f629a2506c$var$load("9aQIt"),
    $0d4643f629a2506c$var$load("XZauT"),
    $0d4643f629a2506c$var$load("4S1SF"),
    $0d4643f629a2506c$var$load("lm9Lt"),
    $0d4643f629a2506c$var$load("9wPDc"),
    $0d4643f629a2506c$var$load("1MWOL"),
    $0d4643f629a2506c$var$load("6fQco"),
    $0d4643f629a2506c$var$load("aOY32"),
    $0d4643f629a2506c$var$load("3MYQs"),
    $0d4643f629a2506c$var$load("6SWFK"),
    $0d4643f629a2506c$var$load("5zapo"),
    $0d4643f629a2506c$var$load("jiFtb"),
    $0d4643f629a2506c$var$load("6wr18"),
    $0d4643f629a2506c$var$load("9atVd"),
    $0d4643f629a2506c$var$load("dek7I"),
    $0d4643f629a2506c$var$load("6iz6l"),
    $0d4643f629a2506c$var$load("4SCW2"),
    $0d4643f629a2506c$var$load("fdKpi"),
    $0d4643f629a2506c$var$load("ffEVr"),
    $0d4643f629a2506c$var$load("hhss7"),
    $0d4643f629a2506c$var$load("5JkDi"),
    $0d4643f629a2506c$var$load("eTYdV"),
    $0d4643f629a2506c$var$load("Wowvf"),
    $0d4643f629a2506c$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("9cyue"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("9cyue", function(module, exports) {

let $6b2ffc638e5aab0c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b2ffc638e5aab0c$var$load("cRtGo"),
    $6b2ffc638e5aab0c$var$load("hCiBy"),
    $6b2ffc638e5aab0c$var$load("6wr18"),
    $6b2ffc638e5aab0c$var$load("3j4Bc"),
    $6b2ffc638e5aab0c$var$load("2tIxk"),
    $6b2ffc638e5aab0c$var$load("dLq4a"),
    $6b2ffc638e5aab0c$var$load("27glK"),
    $6b2ffc638e5aab0c$var$load("bvY53"),
    $6b2ffc638e5aab0c$var$load("ffEVr"),
    $6b2ffc638e5aab0c$var$load("hjqVy"),
    $6b2ffc638e5aab0c$var$load("lPWNR"),
    $6b2ffc638e5aab0c$var$load("eTYdV"),
    $6b2ffc638e5aab0c$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("1Kzjx"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("1Kzjx", function(module, exports) {

let $14657aff74c3391a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14657aff74c3391a$var$load("jduRX"),
    $14657aff74c3391a$var$load("h3ABO"),
    $14657aff74c3391a$var$load("5o4Kn"),
    $14657aff74c3391a$var$load("6rS39"),
    $14657aff74c3391a$var$load("iEUHW"),
    $14657aff74c3391a$var$load("kbwlB"),
    $14657aff74c3391a$var$load("2YffH"),
    $14657aff74c3391a$var$load("9XOeB"),
    $14657aff74c3391a$var$load("xu7ej"),
    $14657aff74c3391a$var$load("iQ4FP"),
    $14657aff74c3391a$var$load("89s90"),
    $14657aff74c3391a$var$load("grTPo"),
    $14657aff74c3391a$var$load("73TmC"),
    $14657aff74c3391a$var$load("k3Yy8"),
    $14657aff74c3391a$var$load("jEvZI"),
    $14657aff74c3391a$var$load("im1VN"),
    $14657aff74c3391a$var$load("eD3Si"),
    $14657aff74c3391a$var$load("9anPW"),
    $14657aff74c3391a$var$load("84qtb"),
    $14657aff74c3391a$var$load("iJxH8"),
    $14657aff74c3391a$var$load("aapZc"),
    $14657aff74c3391a$var$load("gnDXu"),
    $14657aff74c3391a$var$load("5XC9j"),
    $14657aff74c3391a$var$load("iqTGf"),
    $14657aff74c3391a$var$load("3q2Ng"),
    $14657aff74c3391a$var$load("jRpDi"),
    $14657aff74c3391a$var$load("jUBhK"),
    $14657aff74c3391a$var$load("ddJJa"),
    $14657aff74c3391a$var$load("f6ci5"),
    $14657aff74c3391a$var$load("lTK3c"),
    $14657aff74c3391a$var$load("1WXdc"),
    $14657aff74c3391a$var$load("48Wo5"),
    $14657aff74c3391a$var$load("fhn6K"),
    $14657aff74c3391a$var$load("b2FtX"),
    $14657aff74c3391a$var$load("gDycF"),
    $14657aff74c3391a$var$load("52H8l"),
    $14657aff74c3391a$var$load("6iz6l"),
    $14657aff74c3391a$var$load("4SCW2"),
    $14657aff74c3391a$var$load("c0JsV"),
    $14657aff74c3391a$var$load("breTf"),
    $14657aff74c3391a$var$load("cY4Ar"),
    $14657aff74c3391a$var$load("5HAR6"),
    $14657aff74c3391a$var$load("arLFU"),
    $14657aff74c3391a$var$load("cRtGo"),
    $14657aff74c3391a$var$load("6wr18"),
    $14657aff74c3391a$var$load("jvHRs"),
    $14657aff74c3391a$var$load("2tIxk"),
    $14657aff74c3391a$var$load("dLq4a"),
    $14657aff74c3391a$var$load("27glK"),
    $14657aff74c3391a$var$load("bvY53"),
    $14657aff74c3391a$var$load("5bjXP"),
    $14657aff74c3391a$var$load("hhss7"),
    $14657aff74c3391a$var$load("Wowvf"),
    $14657aff74c3391a$var$load("ffEVr"),
    $14657aff74c3391a$var$load("hjqVy"),
    $14657aff74c3391a$var$load("lPWNR"),
    $14657aff74c3391a$var$load("jnVKv"),
    $14657aff74c3391a$var$load("hCiBy"),
    $14657aff74c3391a$var$load("7EorR"),
    $14657aff74c3391a$var$load("bgHzk"),
    $14657aff74c3391a$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.67e9aba9.js.map
